export default __webpack_public_path__ + "static/media/Group 55.ff40c8ad.svg";